// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/client/styles/default/billing/payIcon.less
// module id = 3232
// module chunks = 0